// Delivery logs list page (CHG-1643 / Wave 1 Tier 1).
//
// Org-scoped at /delivery-logs. Backend (delivery_logs.py) handles the
// platform-admin-without-org case server-side by showing platform-level
// (org_id IS NULL) rows — no separate /platform/delivery-logs route is
// needed.
//
// Spec: specs/tier-05-experience/delivery-logs.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { deliveryLogsListConfig } from "../screens/delivery-logs-list";

export function DeliveryLogs() {
  return <ListPage config={deliveryLogsListConfig} />;
}
